var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75254 16.6585C2.56461 16.6585 2.4122 16.5106 2.4122 16.3281V2.67186C2.4122 2.48943 2.56461 2.34149 2.75254 2.34149H16.9996C16.8315 1.02336 15.6707 0 14.2685 0H2.75254C1.23494 0 0 1.19837 0 2.67186V16.3281C0 17.8013 1.23494 19 2.75254 19H14.2685C15.6711 19 16.8315 17.9766 17 16.6585H2.75254Z",
    fill: "#F1F3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 11.2615H14.9456V13.6873C14.9456 13.9277 15.1821 14.0779 15.3715 13.9577L20.8581 9.77037C21.0473 9.65027 21.0473 9.3497 20.8581 9.22959L15.3715 5.04227C15.1822 4.92216 14.9456 5.0723 14.9456 5.31266V7.73848H10",
    fill: "#F1F3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 9,
    fill: "white",
    transform: "translate(10 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.73dd79e2993cb888460548c6af9bbcd0.svg";
export { ForwardRef as ReactComponent };